import { makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { useFormState, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormMaskedText } from "../../../../yoello-lib/modules/dynamicForms/FormComponents/FormMaskedText";
import { FormErrors } from "../../../../yoello-lib/modules/dynamicForms/FormErrors";
import ICommonFormProps from "../../../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps";

const useStyles = makeStyles({
    text: {
        fontSize: "0.9rem",
        color: "#616161",
        padding: 0,
        margin: 0,
        fontWeight: 600
    }
})

const BANK_NAME = "bank_name";
const ACCOUNT_NAME = "account_name"
const ACCOUNT_NUMBER = "account_number";
const SORT_CODE = "sort_code";

export function OBformEntity(props: ICommonFormProps) {
    const { control } = props;
    const { t } = useTranslation();
    const { text } = useStyles();
    const { errors } = useFormState({
        control
    })
    const enabled = useWatch({
        control,
        name: 'enabled'
    })

    if (!enabled) return null;

    const bankLabel = t('openBanking.form.bankLabel');
    const accLabel = t('openBanking.form.accLabel');
    const accNoLabel = t('openBanking.form.accNoLabel');
    const sortLabel = t('openBanking.form.sortLabel');

    return <Grid container
        spacing={3}>
        <Grid item xs={12}>
            <p className={text}>{t("openBanking.form.info")}</p>
        </Grid>
        <Grid item xs={5}>
            <FormMaskedText {...props} formProps={{maskOnChange: checkFirstCharachterNotBeSpace}} keyName={BANK_NAME} errors={errors[BANK_NAME]} label={bankLabel} registerOptions={{ required: true }} />
            <FormErrors {...props} keyName={BANK_NAME} label={bankLabel} />

        </Grid>
        <Grid item xs={5}>
            <FormMaskedText {...props} formProps={{maskOnChange: checkFirstCharachterNotBeSpace}} keyName={ACCOUNT_NAME} errors={errors[ACCOUNT_NAME]} label={accLabel} registerOptions={{ required: true }} />
            <FormErrors {...props} keyName={ACCOUNT_NAME} label={accLabel} />

        </Grid>
        <Grid item xs={5}>
            <FormMaskedText {...props} formProps={{maskOnChange: checkAccountNumber}} keyName={ACCOUNT_NUMBER} errors={errors[ACCOUNT_NUMBER]} label={accNoLabel} registerOptions={{ required: true , maxLength:8 , minLength: 8  }} />
            <FormErrors {...props} keyName={ACCOUNT_NUMBER} label={accNoLabel} />
        </Grid>
        <Grid item xs={5}>
            <FormMaskedText {...props} keyName={SORT_CODE} errors={errors[SORT_CODE]} label={sortLabel}
                registerOptions={{ required: true, minLength: 8, maxLength: 8}}
                formProps={{
                    maskOnChange: splitSortCode
                }}
            />
            <FormErrors {...props} keyName={SORT_CODE} label={sortLabel} />
        </Grid>
    </Grid>
}
 function checkFirstCharachterNotBeSpace(value: string) {
    return value.trimStart();
  }
  function checkAccountNumber(value: string) {
      if(value.length>8)
      return value.slice(0, -1);
    const lastCharachter = value.slice(-1);
    if (isNaN(lastCharachter as any)||lastCharachter===" ") return value.slice(0, -1);

    return value;
  }
export function splitSortCode(value: string) {

    if(value.length>8)
    return value.slice(0, -1);
    if(value!=='******'){
     const lastCharachter = value.slice(-1);
     if (isNaN(lastCharachter as any)||lastCharachter===" ") return value.slice(0, -1);
    }

    const newValue = value.replace(/-/g, "");
    let string = "";
    const length = newValue.length;
    for (let i = 0; i < length; i++) {
        /**Splits the text by every 2 and if its the last entry */
        const isSplit = !!(i % 2 && (i + 1 !== length));

        string += newValue[i];
        if (isSplit) {
            string += '-';
        }
    }

    return string;
}